import { useEffect, useState } from 'react';
import { Menu, MenuProps } from 'antd';
import { AuthProvider } from '../../Providers/authProvider';
import { TextService } from '../../Services/TextService';
import { MailOutlined, UserOutlined, TeamOutlined, UserSwitchOutlined, IdcardOutlined, PictureOutlined, UnorderedListOutlined, DatabaseFilled, DatabaseOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { getCurrentLanguage } from '../../Helpers/RouteHelper';
import { AuthenticatedUser } from '../../Types/AuthenticatedUser';
import { CompanyRole } from '../../Types/CompanyRole';
import { CustomListService } from '../../Services/CustomListService';

const LeftMenu = (props: any) => {
    const [current, setCurrent] = useState('1');
    const [user, setUser] = useState({} as AuthenticatedUser | null);
    const [customLists, setCustomLists] = useState<any[]>([]);
    const GetText = TextService.GetText;
    const navigation = useNavigate();

    useEffect(() => {
        AuthProvider().GetLoggedInUser().then(user => {
            setUser(user);
        });

        // Fetch custom lists for menu
        CustomListService.GetCustomLists().then(lists => {
            setCustomLists(lists || []);
        });
    }, []);

    // Update selected menu item when props.selected changes
    useEffect(() => {
        setCurrent(props.selected);
    }, [props.selected]);

    type MenuItem = Required<MenuProps>['items'][number];

    const onClick: MenuProps['onClick'] = (e: any) => {
        navigation("/" + getCurrentLanguage() + "/" + e.key);
    };

    function getItem(
        label: React.ReactNode,
        key?: React.Key | null,
        icon?: React.ReactNode,
        children?: MenuItem[],
        type?: 'group',
    ): MenuItem {
        return {
            key,
            icon,
            children,
            label,
            type,
        } as MenuItem;
    }

    const customListMenuItems: MenuItem[] = customLists.length > 0
        ? [
            getItem(GetText('CustomListSettings_Title'), 'customListsHeader', undefined, undefined, 'group'),
            ...customLists.map(list =>
                getItem(list.name, `customList/${list.id}`, <DatabaseOutlined />)
            )
        ]
        : [];

    const items: MenuItem[] = user?.role == CompanyRole.GlobalAdmin ? [
        getItem(GetText("Users_UsersTitle"), 'users', <UserOutlined />),
        getItem(GetText("Groups_GroupsTitle"), 'groups', <TeamOutlined />),

        getItem(GetText("Users_UserHistoryTitle"), 'userHistory', <IdcardOutlined />),
        getItem(GetText("PictureArchive_Title"), 'picturearchive', <PictureOutlined />),
        ...customListMenuItems,
    ] : [
        getItem(GetText("Users_UsersTitle"), 'users', <UserOutlined />),
        getItem(GetText("Groups_GroupsTitle"), 'groups', <TeamOutlined />),
        getItem(GetText("PictureArchive_Title"), 'picturearchive', <PictureOutlined />),
        ...customListMenuItems,
    ];

    return <Menu
        theme="light"
        onClick={onClick}
        defaultOpenKeys={['sub1']}
        selectedKeys={[current]}
        mode="inline"
        items={items}
    />
};

export default LeftMenu;